import dynamic from 'next/dynamic';

export * from './lib/types';

export const NoSSREditorReact = dynamic(() => import('./lib/editor-react').then((module) => module.EditorReact), {
  ssr: false,
});
